import { ArrowLeftOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Card, Col, Input, Row, Typography, message } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PRIMARY_RED } from "../../constants/colors";

const { Title, Text } = Typography;

const EditForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formName, setFormName] = useState("");
  const [formDescription, setFormDescription] = useState("");
  const [pdfFile, setPdfFile] = useState(null); // New uploaded file
  const [existingPdfUrl, setExistingPdfUrl] = useState(""); // Existing file link

  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const token = authUser?.token;

  useEffect(() => {
    const fetchForm = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASEURL}/form/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const { formName, formDescription, pdfUrl } = response.data;
        setFormName(formName);
        setFormDescription(formDescription);
        setExistingPdfUrl(pdfUrl); // assumes backend returns full URL
      } catch (err) {
        message.error("Failed to fetch form data");
      }
    };

    fetchForm();
  }, [id, token]);

  const handleUpdate = async () => {
    if (!formName || !formDescription) {
      message.warning("All fields are required");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("formName", formName);
      formData.append("formDescription", formDescription);
      if (pdfFile) {
        formData.append("pdfs", pdfFile); // field name depends on your backend
      }

      await axios.put(`${process.env.REACT_APP_API_BASEURL}/form/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      message.success("Form updated successfully");
      navigate("/form");
    } catch (err) {
      message.error("Failed to update form");
    }
  };

  return (
    <div className="p-4">
      <Card title="Edit Form">
        <Row gutter={16}>
          <Col span={12}>
            <Text strong>Form Name</Text>
            <Input
              value={formName}
              onChange={(e) => setFormName(e.target.value)}
              placeholder="Form name"
              style={{ marginBottom: 20 }}
            />
          </Col>
          <Col span={12}>
            <Text strong>Description</Text>
            <Input
              value={formDescription}
              onChange={(e) => setFormDescription(e.target.value)}
              placeholder="Description"
              style={{ marginBottom: 20 }}
            />
          </Col>
        </Row>

        {/* Show existing PDF */}
        {existingPdfUrl && (
          <div style={{ marginBottom: 20 }}>
            <Text>
              Existing PDF:{" "}
              <a href={existingPdfUrl} target="_blank" rel="noopener noreferrer">
                View PDF
              </a>
            </Text>
          </div>
        )}

        {/* Upload new PDF */}
        <div
          style={{
            border: "2px dashed #d9d9d9",
            padding: "40px",
            textAlign: "center",
            marginBottom: "20px",
            borderRadius: "8px",
            cursor: "pointer",
          }}
          onClick={() => document.getElementById("pdfUpload").click()}
        >
          <img
            src="https://cdn-icons-png.flaticon.com/512/1828/1828491.png"
            alt="Upload"
            style={{ width: "40px", marginBottom: "10px", opacity: 0.5 }}
          />
          <div style={{ fontWeight: 600, fontSize: "16px" }}>
            Drop file here to upload
          </div>
          <input
            id="pdfUpload"
            type="file"
            accept="application/pdf"
            onChange={(e) => setPdfFile(e.target.files[0])}
            style={{ display: "none" }}
          />
        </div>

        {/* Buttons */}
        <Row gutter={16}>
          <Col>
            <Button type="primary" icon={<EditOutlined />} style={{ backgroundColor: PRIMARY_RED }} onClick={handleUpdate}>
              Edit Form
            </Button>
          </Col>
          <Col>
            <Button
              type="link"
              style={{ color: PRIMARY_RED }}
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate("/form")}
            >
              Back
            </Button>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default EditForm;
